import { render, staticRenderFns } from "./notificationForm.vue?vue&type=template&id=017c55b2&scoped=true"
import script from "./notificationForm.vue?vue&type=script&lang=js"
export * from "./notificationForm.vue?vue&type=script&lang=js"
import style0 from "./notificationForm.vue?vue&type=style&index=0&id=017c55b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017c55b2",
  null
  
)

export default component.exports